var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-steps-screen-carousel" }, [
    _c("img", {
      staticClass: "home-steps-screen-carousel-base-image",
      attrs: { src: "imgs/empty-phone.webp" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "home-steps-screen-carousel-container" }, [
      _c(
        "div",
        {
          staticClass: "home-steps-screen-carousel-container-inner",
          style: { "margin-left": "-" + _vm.offset + "%" }
        },
        _vm._l(5, function(i) {
          return _c("img", {
            key: i,
            attrs: {
              src: "/imgs/how-it-works/" + i + "-" + _vm.locale + ".webp"
            }
          })
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-624309ad", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624309ad","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeStepsScreenCarousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-624309ad","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeStepsScreenCarousel.vue
// module chunks = 1 2 3